import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "../api/fetchProducts";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useFetchProducts = () => {
    return useQuery({
        queryKey: withPrefix(['products']),
        queryFn: fetchProducts,
    })
}
